import React from 'react';

const SubjectPerformance = ({ size, color, percentage, data }) => {
  const radius = size / 2;

  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <>
    <svg width={size} height={size} >
     
      <circle
        cx={radius}
        cy={radius}
        r={radius -3}
        // fill="transparent"
        fill="#FFF"
        stroke={color}
        strokeDasharray={strokeDasharray}
        transform={`rotate(-90 ${radius} ${radius})`}
        strokeDashoffset={strokeDashoffset}
        strokeWidth="5px" 
      />
      <text
        x={radius}
        y={radius}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={radius / 3}
        fill={color}
      >
        <tspan x={radius} dy={-radius/4}>{percentage}%</tspan>
          <tspan x={radius} dy={radius / 2}>{data }</tspan>
      </text>
    </svg>
    </>
  );
};

export default SubjectPerformance;
